import React from 'react';
import { usePriceContext } from 'contracts/utils/priceContext';
import { ContractTextInput } from './ContractFields';

function Markups() {
  const {
    importMarkup,
    importMarkupUsdLb,
    otherMarkups,
    otherMarkupsUsdLb,
    // incoterm,
    fixedPriceType,
    contractPricesCustomerToUsdRate,
    measurementRate,
    sameCurrencyUnitofMeasure,
  } = usePriceContext();

  // Validar funcionalidad de isFCAorDDP
  // const isFCAorDDP = () => {
  //   return incoterm == 'FCA' || incoterm == 'DDP';
  // };

  const handleMarkupChange = (value, setMarkupUsdLb, setMarkup) => {
    setMarkupUsdLb(String(value));
    if (fixedPriceType?.value == 'fixed') {
      setMarkup(
        String(
          (
            (Number(value) / Number(measurementRate)) *
            Number(contractPricesCustomerToUsdRate?.value)
          ).toFixed(4)
        )
      );
    } else if (fixedPriceType?.value == 'differential') {
      setMarkup(value);
    }
  };

  return (
    <>
      {importMarkupUsdLb && (
        <ContractTextInput
          field={importMarkupUsdLb.field}
          value={importMarkupUsdLb.value}
          onChange={(value) => {
            handleMarkupChange(value, importMarkupUsdLb.set, importMarkup?.set);
          }}
          type='number'
          step='0.0001'
          min='0.00'
        />
      )}

      {fixedPriceType?.value === 'fixed' &&
        importMarkup &&
        !sameCurrencyUnitofMeasure && (
          <ContractTextInput
            field={importMarkup.field}
            value={importMarkup.value}
            onChange={importMarkup?.set}
            type='number'
            step='0.0001'
            min='0.00'
          />
        )}

      {otherMarkupsUsdLb && (
        <ContractTextInput
          field={otherMarkupsUsdLb.field}
          value={otherMarkupsUsdLb.value}
          onChange={(value) => {
            otherMarkupsUsdLb.set;
            handleMarkupChange(value, otherMarkupsUsdLb?.set, otherMarkups?.set);
          }}
          // readOnly={
          //   fixedPriceType?.value == 'fixed' ? otherMarkups.field.readonly : isFCAorDDP()
          // }
          type='number'
          step='0.0001'
          min='0.00'
        />
      )}

      {fixedPriceType?.value === 'fixed' &&
        otherMarkups &&
        !sameCurrencyUnitofMeasure && (
          <ContractTextInput
            field={otherMarkups.field}
            value={otherMarkups.value}
            onChange={otherMarkups.set}
            type='number'
            step='0.0001'
            min='0.00'
          />
        )}
    </>
  );
}

export default Markups;
